module.exports = __webpack_public_path__ + "img/02-2727ef.png";